<div class="page-break-before spacing--margin-top" data-test="scheme-graph">
  <h3 class="spacing-top">{{ 'feed-advice-detail.graph' | translate }}</h3>
  <div class="screen-only spacing--margin-top y-axes-container">
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-graph.y-axis-label' | translate }}
      </span>
      <mat-radio-group (change)="changeSetting()" [(ngModel)]="yAxis">
        <mat-radio-button
          data-test="scheme-graph_left_energy-radiobutton"
          class="text--small"
          color="primary"
          value="energy"
        >
          {{ 'scheme-table.energy_value' | translate }}
        </mat-radio-button>
        <mat-radio-button
          data-test="scheme-graph_left_lysine-radiobutton"
          class="text--small"
          color="primary"
          value="lysine"
        >
          {{ 'scheme-table.lysine' | translate }}
        </mat-radio-button>
        <mat-radio-button
          data-test="scheme-graph_left_feedintake-radiobutton"
          class="text--small"
          color="primary"
          value="feedintake"
        >
          {{ 'scheme-table.feed_per_day' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="print-only spacing--margin-top">
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-graph.y-axis-label' | translate }}
        {{ 'feed-advice-graph.' + yAxis | translate }}
      </span>
    </div>
  </div>
  <div class="flex__child--auto chart-container">
    <agr-chart [options]="chartOptions" [dataSource]="chartSeries"></agr-chart>
  </div>
</div>
